/*
XXX_JSREFACTOR_XXX
todo @JSREFACTOR
    - write unit tests for different use cases
*/

import { Serialize } from 'root/utils/serialize/serialize';

const SerializeForm = function () {
    const pair = function (key, value) {
        this.key = key;
        this.value = value;
    };
    pair.prototype = {
        getKey() {
            return this.key;
        },
        getValue() {
            return this.value;
        },
        isSet() {
            return typeof this.key !== 'undefined' && typeof this.value !== 'undefined';
        },
    };

    function form(formElement) {
        const data = scrapeForm(formElement);
        return Serialize(data);
    }

    function scrapeForm(formElement) {
        const obj = {};
        const formElements = formElement.querySelectorAll('input, select, textarea');
        for (let i = 0; i < formElements.length; ++i) {
            // skip disabled fields from serialization
            if (formElements[i].disabled) continue;
            const pair = getKeyValuePairFormElement(formElements[i], obj);
            if (pair.isSet()) {
                obj[pair.getKey()] = pair.getValue();
            }
        }
        return obj;
    }

    function getKeyValuePairFormElement(formElement, serializedValuesObj = {}) {
        const formElementType = formElement.type;
        switch (formElementType) {
            case 'radio': {
                if (formElement.checked) {
                    // return value of checked radio input
                    return new pair(formElement.name, formElement.value);
                }
                if (
                    !formElement.checked &&
                    serializedValuesObj[formElement.name] &&
                    serializedValuesObj[formElement.name] !== ''
                ) {
                    // if the current radio input is not checked, but a value for this input's name already exists, return the same value
                    return new pair(
                        formElement.name,
                        serializedValuesObj[formElement.name]
                    );
                }
                // default to returning an 'empty' value until a checked radio input value is found and saved
                return new pair(formElement.name, '');
            }
            case 'checkbox': {
                const isChecked = formElement.checked ? 1 : 0;
                return new pair(formElement.name, isChecked);
            }
            default:
                return new pair(formElement.name, formElement.value);
        }
    }

    return {
        form,
    };
};

export { SerializeForm };
